"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _getButtonLoadingStyles = require("../styled/getButtonLoadingStyles");
var _getButtonPadding = require("../styled/getButtonPadding");
const getMargin = (hasLeftIcon, hasRightIcon, appearance, size) => {
  switch (appearance) {
    // For Lodestar buttons.
    case "borderless":
    case "primary":
    case "secondary":
    case "destructive":
    case "secondary-destructive":
    case "share":
      // Icons already provide a margin, so the content is only responsible for edges without an icon
      if (hasLeftIcon && hasRightIcon) {
        return {
          margin: `0`
        };
      }
      if (hasLeftIcon) {
        return {
          marginRight: `var(--sds--button--gap--${size}, ${_spacing.sizes.small - 1}px)`
        }; // -1px for border
      }

      if (hasRightIcon) {
        return {
          marginLeft: `var(--sds--button--gap--${size}, ${_spacing.sizes.small - 1}px)`
        };
      }
      // Proper spacing will be provided by the button padding if there are no icons present
      return {
        margin: `0`
      };

    // For Ursa buttons.
    case "primary-filled":
    case "primary-empty":
    case "secondary-filled":
    case "secondary-outlined":
    case "secondary-empty":
    case "canvas-filled":
    case "canvas-empty":
    case "destructive-filled":
    case "destructive-empty":
      // Icons already provide a margin, so the content is only responsible for edges without an icon
      if (hasLeftIcon && hasRightIcon) {
        return {
          margin: `0 var(--sds--button--gap--${size}, 1px)`
        };
      }
      if (hasLeftIcon) {
        // -1px for border, opposite side +1px to account for the -1 on the icon
        return {
          marginRight: `var(--sds--button--gap--${size}, calc(${_getButtonPadding.ursaPadding[size]} - 1px))`,
          marginLeft: `var(--sds--button--gap--${size}, 1px)`
        };
      }
      if (hasRightIcon) {
        return {
          marginLeft: `var(--sds--button--gap--${size}, calc(${_getButtonPadding.ursaPadding[size]} - 1px))`,
          marginRight: `var(--sds--button--gap--${size}, 1px)`
        };
      }
      // Proper spacing will be provided by the button padding if there are no icons present
      return {
        margin: `0`
      };
  }
};
const Content = (0, _styled.default)("span")`
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${_ref => {
  let {
    isLoading
  } = _ref;
  return (0, _getButtonLoadingStyles.getButtonLoadingStyles)(isLoading);
}}
    ${_ref2 => {
  let {
    hasLeftIcon,
    hasRightIcon,
    appearance,
    size
  } = _ref2;
  return getMargin(hasLeftIcon, hasRightIcon, appearance, size);
}}
`;
exports.Content = Content;
//# sourceMappingURL=Content.js.map